export default "__VITE_ASSET__BoZuS58V__"